import './MyLocationButton.scss'

import { HDSButton } from '@here/hds-react-components'
import { UserPosition } from 'data/model'
import { RootState } from 'data/reducer'
import { fetchCurrentPosition } from 'data/reducer/user'
import { useAppDispatch, useAppSelector } from 'data/store/hooks'
import React, { useCallback } from 'react'

interface MapZoomControlsProps {
  handleLookAtPosition: (userPosition: UserPosition) => void
}

export default function MyLocationButton({
  handleLookAtPosition,
}: MapZoomControlsProps): JSX.Element {
  const dispatch = useAppDispatch()
  const userPosition = useAppSelector((state: RootState) => state.user.currentPosition)
  const errorPosition = useAppSelector((state: RootState) => state.user.error)

  const goToUserPosition = (): void => {
    dispatch(fetchCurrentPosition())
    if (userPosition !== null) {
      handleLookAtPosition(userPosition)
    }
  }

  const handleCenterButtonClick = useCallback(goToUserPosition, [
    dispatch,
    handleLookAtPosition,
    userPosition,
  ])

  // "variant: 'subtle'" sets background-color to white but also sets icon color to grey
  // "variant: 'danger'" sets background-color to dark red, which is a temporary way to express an error through UI
  return (
    <div className="MyLocationButton__group">
      <HDSButton
        disabled={errorPosition !== null ? true : false}
        icon="view-center"
        iconCategory="map-view"
        loading={errorPosition !== null || userPosition !== null ? false : true}
        size="medium"
        variant="subtle"
        onClick={handleCenterButtonClick}
      />
    </div>
  )
}
